export default __webpack_public_path__ + "static/media/faq.6a7355da.png";